// Static configuration constants — UI/config constants.

export const IMG = {
    hero: "/images/hero.webp",
    riceCurry: "https://images.unsplash.com/photo-1589301760014-d929f3979dbc?auto=format&fit=crop&w=800&q=80",
    kottu: "/images/default_menu.webp",
    hoppers: "https://images.unsplash.com/photo-1626777552726-4a6b54c97e46?auto=format&fit=crop&w=800&q=80",
    shortEats: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&w=800&q=80",
    biriyani: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?auto=format&fit=crop&w=800&q=80",
    dessert: "https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&w=800&q=80",
};

export const cities = ["Helsinki", "Espoo", "Vantaa", "Tampere", "Turku", "Oulu"];

export const businessTypes = ["Restaurant", "Home-based kitchen", "Caterer", "Food store", "Bakery", "Food truck"];

// Default fallback image for menu items without an image
export const DEFAULT_MENU_IMAGE = IMG.kottu;